import PropTypes from "prop-types";

function SelectInput({ name, options, label, placeholder, error, onChange }) {
  const mapOptions = options.map((option) => {
    return (
      <option key={option} value={option}>
        {option}
      </option>
    );
  });
  return (
    <div className="select-input flex flex-col mb-4">
      {label && <label className="label mb-2 text-gray-500">{label}</label>}
      <select onChange={onChange} name={name} className="border rounded focus:outline-none focus:border-none">
        <option value="" disabled selected hidden>
          {placeholder}
        </option>
        {mapOptions}
      </select>
      {error && error.name === name && <small className="error">{error.message}</small>}
    </div>
  );
}

SelectInput.propTypes = {
  options: PropTypes.array,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.object,
};

export default SelectInput;
